import books from './bibleBooks.json';
import abbreviationMap from './bibleBookAbbreviationMap.json';
import bibleBooksSimple from './bibleBooksSimple.json';

class BibleReferenceUtility {
  static getBookValue() {
    return 30000;
  }

  static getChapterValue() {
    return 200;
  }

  static getMin(passage) {
    const bookRegex = /^[123]? ?[a-z]+/i;
    const bookMatches = bookRegex.exec(passage);
    if (bookMatches && bookMatches.length > 0) {
      const book = bookMatches[0];
      passage = passage.replace(bookRegex, '');
      const bookIndex = BibleReferenceUtility.getBookIndex(book);
      if (passage.includes('-')) {
        passage = passage.split('-')[0].trim();
      }
      let chapterSide = passage;
      let verseSide = '';
      if (passage.includes(':')) {
        chapterSide = passage.split(':')[0];
        verseSide = passage.split(':')[1];
      }
      const numberRegex = /\d+/;
      const chapterResult = numberRegex.exec(chapterSide);
      const verseResult = numberRegex.exec(verseSide);
      if (chapterResult && chapterResult.length > 0) {
        const chapter = Number(chapterResult[0]) - 1;
        let verse = 0;
        if (verseResult && verseResult.length > 0) {
          verse = Number(verseResult[0]) - 1;
        }
        return (
          BibleReferenceUtility.getBookValue() * bookIndex +
          BibleReferenceUtility.getChapterValue() * chapter +
          verse
        );
      } else {
        return BibleReferenceUtility.getBookValue() * bookIndex;
      }
    }
    return -1;
  }

  static getMax(passage) {
    const bookRegex = /[123] [a-z]+|[a-z]+/i;
    const sides = passage.split('-');
    passage = sides[sides.length - 1];
    const bookMatches = bookRegex.exec(passage);
    if (bookMatches && bookMatches.length > 0) {
      const book = bookMatches[0];
      passage = passage.replace(bookRegex, '');
      const bookIndex = BibleReferenceUtility.getBookIndex(book);
      let chapterSide = passage;
      let verseSide = '';
      if (passage.includes(':')) {
        chapterSide = passage.split(':')[0];
        verseSide = passage.split(':')[1];
      }
      const numberRegex = /\d+/;
      const chapterResult = numberRegex.exec(chapterSide);
      const verseResult = numberRegex.exec(verseSide);
      if (chapterResult && chapterResult.length > 0) {
        const chapter = Number(chapterResult[0]) - 1;
        let verse = BibleReferenceUtility.getChapterValue() - 1;
        if (verseResult && verseResult.length > 0) {
          verse = Number(verseResult[0]) - 1;
        }
        return (
          BibleReferenceUtility.getBookValue() * bookIndex +
          BibleReferenceUtility.getChapterValue() * chapter +
          verse
        );
      } else {
        return BibleReferenceUtility.getBookValue() * (bookIndex + 1) - 1;
      }
    }
    return -1;
  }

  static getBookIndex(book) {
    return bibleBooksSimple.indexOf(book);
  }

  static expandPassage(passage) {
    try {
      passage = passage.trim();
      passage = passage.replace(/[:-]$/, '');
      //Match the first reference
      const regex = /^([123]? ?[a-z]+)\s?(\d+:?\s?(?:\d?)+)/i;
      const matches = regex.exec(passage);
      let book = null;
      let reference = null;
      if (!matches) {
        const bookRegex = /^[123]? ?[a-z]+/i;
        const bookMatches = bookRegex.exec(passage);
        if (bookMatches && bookMatches.length > 0) {
          book = bookMatches[0].trim();
        }
      } else {
        book = matches[1].trim();
        reference = matches[2].trim();
      }
      book = BibleReferenceUtility.getFullBookName(book);
      if (book && !reference && !passage.includes('-')) {
        return {expanded: `${book}`};
      }
      if (passage.includes('-')) {
        const finalTest = /^([123] [a-z]+|[a-z]+) ?((\d+:\d+)|\d+)? - ([123] [a-z]+|[a-z]+) ?((\d+:\d+)|\d+)?$/i;
        let secondHalf = passage.split('-')[1].trim();
        //If there is no colon, for example, Genesis 1:1-10, replace the 10 with 1:10
        if (!secondHalf.includes(':') && reference && reference.includes(':')) {
          secondHalf = `${reference.split(':')[0]}:${secondHalf}`;
        }
        //If there is no book name given, insert the name of the book in the second half
        if (!/[a-z]/i.test(secondHalf) && reference) {
          secondHalf = `${book} ${secondHalf}`;
        } else {
          const secondBookRegex = /[123]? ?[a-z]+/i;
          const secondBookAbbreviation = secondBookRegex.exec(secondHalf)[0];
          let secondBook = BibleReferenceUtility.getFullBookName(
            secondBookAbbreviation
          );
          if (secondBook) {
            secondHalf = `${secondBook}${secondHalf.replace(
              secondBookRegex,
              ''
            )}`;
          } else {
            return {
              error: `The book "${secondBookAbbreviation}" was not recognized`
            };
          }
        }
        if (reference) {
          const ret = `${book} ${reference} - ${secondHalf}`;
          if (finalTest.test(ret)) {
            return {expanded: ret};
          }
          return {error: `${passage} was not recognized as a valid reference`};
        } else {
          return {expanded: `${book} - ${secondHalf}`};
        }
      } else {
        const finalTest = /([123] [a-z]+|[a-z]+) ?((\d+:\d+)|\d+)$/i;
        const ret = `${book} ${reference}`;
        if (finalTest.test(ret)) {
          return {expanded: ret};
        }
        return {error: `${passage} was not recognized as a valid reference`};
      }
    } catch (exception) {
      return {error: `${passage} was not recognized as a valid reference`};
    }
  }

  static getBooks() {
    return books;
  }

  static getFullBookName(abbreviation) {
    const expanded = abbreviationMap[abbreviation.toLowerCase()];
    if (expanded) return expanded;
    let ret = '';
    books.forEach(book => {
      if (book.book.toLowerCase() === abbreviation.toLowerCase())
        ret = book.book;
    });
    return ret;
  }
}

export default BibleReferenceUtility;
